/** Тренажёр решений (PULSE-476): публичные эндпоинты по токену участника. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { MarketSeries } from '@/hooks/useMarketApi'

export interface DrillOverview {
  name: string; total: number; done: number; next_ord: number | null
  sessions: { session: number; done: number; ords: { ord: number; status: 'new' | 'open' | 'done' }[] }[]
}
export interface DrillAction { id: number; at: string; revealed_s: number; type: string; payload: Record<string, any> }
export interface DrillPosition {
  side: 'short' | 'long' | null; avg: number | null; units: number; stop: number | null; target: number | null
  realized: number; decided: string | null
}
export interface DrillEvent {
  ord: number; session: number; total: number; tf: string; event_t: number; edge_t: number
  revealed_s: number; horizon_s: number; status: 'open' | 'done'; price_now: number | null
  series: MarketSeries; actions: DrillAction[]; position: DrillPosition
}

export function useDrillOverview(token?: string) {
  return useQuery({
    queryKey: ['drill', token],
    queryFn: async () => (await api.get<DrillOverview>(`/drill/${token}`)).data,
    enabled: !!token,
  })
}

export function useDrillEvent(token: string | undefined, ord: number, tf: string) {
  return useQuery({
    queryKey: ['drill', token, ord, tf],
    queryFn: async () => (await api.get<DrillEvent>(`/drill/${token}/event/${ord}`, { params: { tf } })).data,
    enabled: !!token && ord > 0,
    placeholderData: (prev) => prev,
  })
}

export function useDrillMutations(token: string | undefined, ord: number) {
  const qc = useQueryClient()
  const refresh = () => qc.invalidateQueries({ queryKey: ['drill', token] })
  const reveal = useMutation({
    mutationFn: async (seconds: number) => (await api.post(`/drill/${token}/event/${ord}/reveal`, { seconds })).data,
    onSuccess: refresh,
  })
  const act = useMutation({
    mutationFn: async (a: { type: string; payload?: Record<string, any> }) =>
      (await api.post(`/drill/${token}/event/${ord}/action`, { type: a.type, payload: a.payload ?? {} })).data,
    onSuccess: refresh,
  })
  return { reveal, act }
}
